import { render, staticRenderFns } from "./AddProductSidebar.vue?vue&type=template&id=081647a7&scoped=true&"
import script from "./AddProductSidebar.vue?vue&type=script&lang=js&"
export * from "./AddProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddProductSidebar.vue?vue&type=style&index=0&id=081647a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081647a7",
  null
  
)

export default component.exports